import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import CircularProgress from "@mui/material/CircularProgress";

const FetchingSuggestions = () => {
	return (
		<Grid
			container
			flexDirection="column"
			justifyContent="center"
			sx={{ minHeight: "50vh" }}
		>
			<Grid container>
				<Grid
					item
					xs={12}
					display="flex"
					justifyContent="center"
					alignItems="center"
				>
					<Box display="flex" alignItems="center">
						<Typography variant="h3" sx={{ marginRight: 1 }}>
							Analyzing Data from Trackman
						</Typography>
						<CircularProgress size={40} />
					</Box>
				</Grid>
			</Grid>
		</Grid>
	);
};

export default FetchingSuggestions;
